var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1 min-h-screen" }, [
    _c("div", { staticClass: "max-w-4xl mx-auto py-12 px-6" }, [
      _c("div", { staticClass: "text-center mb-12" }, [
        _c(
          "div",
          {
            staticClass:
              "bg-opacity-10 p-4 rounded-full mx-auto w-16 h-16 flex items-center justify-center headerIcon",
          },
          [
            _c(
              "svg",
              {
                staticClass: "lucide lucide-target h-8 w-8 text-blue-600",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                },
              },
              [
                _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                _c("circle", { attrs: { cx: "12", cy: "12", r: "6" } }),
                _c("circle", { attrs: { cx: "12", cy: "12", r: "2" } }),
              ]
            ),
          ]
        ),
        _c("h1", { staticClass: "text-3xl font-semibold text-gray-900 mb-4" }, [
          _vm._v("Smart Match"),
        ]),
        _c(
          "p",
          {
            staticClass:
              "text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed",
          },
          [
            _vm._v(
              " Find the best resources for your clients using our intelligent matching system. Configure your criteria and let our algorithm search your resource database to find the perfect matches ranked by compatibility. "
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" },
        [
          _c(
            "div",
            {
              staticClass:
                "bg-white rounded-xl shadow-sm border border-gray-200 p-8 hover:shadow-md transition-shadow",
            },
            [
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-12 h-12 mx-auto mb-6 bg-blue-100 rounded-full flex items-center justify-center",
                    staticStyle: { "background-color": "#1a7bee1a" },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "w-6 h-6 z-10",
                        staticStyle: { color: "#1A7BEE" },
                        attrs: {
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "h3",
                  { staticClass: "text-xl font-medium text-gray-900 mb-3" },
                  [_vm._v("Configure Smart Match")]
                ),
                _c("p", { staticClass: "text-gray-600 mb-6 leading-relaxed" }, [
                  _vm._v(
                    " Set your matching criteria including client needs, location preferences, resource availability, and priority factors to customize the search algorithm. "
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass:
                      "inline-flex items-center px-6 py-3 bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors",
                    on: { click: _vm.openConfigModal },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "w-4 h-4 mr-2",
                        attrs: {
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" Configure Criteria "),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "bg-white rounded-xl shadow-sm border border-gray-200 p-8 hover:shadow-md transition-shadow",
            },
            [
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-12 h-12 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center",
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "w-6 h-6 text-green-600",
                        attrs: {
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "h3",
                  { staticClass: "text-xl font-medium text-gray-900 mb-3" },
                  [_vm._v("Run Smart Match")]
                ),
                _c("p", { staticClass: "text-gray-600 mb-6 leading-relaxed" }, [
                  _vm._v(
                    " Execute the smart matching algorithm to search through your resource database and receive a ranked list of the best matches for your client. "
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass:
                      "inline-flex items-center px-8 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 transition-colors font-medium",
                    on: { click: _vm.runSearch },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "w-4 h-4 mr-2",
                        attrs: {
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" Run Search "),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "rounded-xl shadow-sm p-8",
          staticStyle: { "background-color": "#f4f5f7" },
        },
        [
          _c("div", { staticClass: "flex items-center mb-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-8 h-8 rounded-lg flex items-center justify-center mr-3",
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "lucide lucide-users h-5 w-5",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" },
                    }),
                    _c("path", { attrs: { d: "M16 3.128a4 4 0 0 1 0 7.744" } }),
                    _c("path", { attrs: { d: "M22 21v-2a4 4 0 0 0-3-3.87" } }),
                    _c("circle", { attrs: { cx: "9", cy: "7", r: "4" } }),
                  ]
                ),
              ]
            ),
            _c("h3", { staticClass: "text-lg font-medium text-gray-900" }, [
              _vm._v("How Smart Match Works"),
            ]),
          ]),
          _vm._m(0),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "grid grid-cols-1 md:grid-cols-4 gap-6" }, [
      _c("div", { staticClass: "text-center" }, [
        _c(
          "div",
          {
            staticClass:
              "w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 font-semibold",
          },
          [_vm._v(" 1 ")]
        ),
        _c("h4", { staticClass: "font-medium text-gray-900 mb-2" }, [
          _vm._v("Configure Criteria"),
        ]),
        _c("p", { staticClass: "text-sm text-gray-600" }, [
          _vm._v(
            " Set your specific needs, preferences, and requirements using your criteria "
          ),
        ]),
      ]),
      _c("div", { staticClass: "text-center" }, [
        _c(
          "div",
          {
            staticClass:
              "w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 font-semibold",
          },
          [_vm._v(" 2 ")]
        ),
        _c("h4", { staticClass: "font-medium text-gray-900 mb-2" }, [
          _vm._v("Run Algorithm"),
        ]),
        _c("p", { staticClass: "text-sm text-gray-600" }, [
          _vm._v(
            " Our algorithm searches through available resources using your criteria "
          ),
        ]),
      ]),
      _c("div", { staticClass: "text-center" }, [
        _c(
          "div",
          {
            staticClass:
              "w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 font-semibold",
          },
          [_vm._v(" 3 ")]
        ),
        _c("h4", { staticClass: "font-medium text-gray-900 mb-2" }, [
          _vm._v("Review Results"),
        ]),
        _c("p", { staticClass: "text-sm text-gray-600" }, [
          _vm._v(" Get ranked matches with compatibility scores "),
        ]),
      ]),
      _c("div", { staticClass: "text-center" }, [
        _c(
          "div",
          {
            staticClass:
              "w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 font-semibold",
          },
          [_vm._v(" 4 ")]
        ),
        _c("h4", { staticClass: "font-medium text-gray-900 mb-2" }, [
          _vm._v("Select Top Picks"),
        ]),
        _c("p", { staticClass: "text-sm text-gray-600" }, [
          _vm._v(
            " Click the bookmark icon to add them to your top picks when scheduling a visit "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }